export default __webpack_public_path__ + "../staticImages/nl_header_desktop.jpg";